import { useEffect } from "react";

export default function useReveal(selector = ".reveal", options = {}) {
  useEffect(() => {
    const els = document.querySelectorAll(selector);
    if (!els.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("reveal--in");
            observer.unobserve(e.target);
          }
        });
      },
      { threshold: 0.15, ...options }
    );

    els.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, [selector, options]);
}
